
"use strict"

// global
import './components/lang-switcher'
import './components/mobileNavigation'
import './components/modal'

// components
import asyncLoadOnScroll from './asyncLoadOnScroll'
import videoLightbox from './components/videoLightbox'
import textCarousel from './components/text-carousel'
import textImageCarousel from './components/text-image-carousel'
import carousel from './components/testimonials'
import tabbedArticles from './components/tabbed-content-article'
import tabbedContent from './components/tabbed-content'
import expand from './components/expand'
import eventsFilter from './components/events-filter'
import teamCarousel from './components/team-carousel'
import nav from './components/nav'
import mobileNav from './components/mobileNavigationToggle'
import jobsFilter from './components/jobs-filter'
import skillsMatcher from './components/skills-matcher.ts'
import multiStepForm from './components/multi-step-form.ts'

// init components
nav()
mobileNav()
videoLightbox()
carousel()
textCarousel()
teamCarousel()
tabbedArticles()
tabbedContent()
eventsFilter()
jobsFilter()
textImageCarousel()
multiStepForm()
skillsMatcher()


// animation loading load when scrolled to
const els = [...document.querySelectorAll('.load')]
els.map(scroll => {
    asyncLoadOnScroll(scroll, function(el) {
        el.classList.add('loaded')
    })
})

// accordion expand
expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})


// basic js/no-js test
document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')


// filter tags
const tags = (() => {
	const els = [...document.querySelectorAll('.tag')]
	els.map(tag => {
		tag.addEventListener('click', event => {
			els.filter(el => el !== tag).map(close)
			tag.classList.toggle('open')
			
			event.stopPropagation()
		})
	})
	const close = el => el.classList.remove('open')
	document.documentElement.addEventListener('click', () => els.map(close))
})()
